/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const getOverrideTimeOptionsParamsTimeZoneMax = 100;

export const getOverrideTimeOptionsParamsLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const getOverrideTimeOptionsParamsLocalTimeRegExp = new RegExp(
  '^(?:[01]\\d|2[0-3]):[0-5]\\d$',
);

export const GetOverrideTimeOptionsParams = zod.object({
  timeZone: zod.string().min(1).max(getOverrideTimeOptionsParamsTimeZoneMax),
  localDate: zod.iso.date().regex(getOverrideTimeOptionsParamsLocalDateRegExp),
  localTime: zod.string().regex(getOverrideTimeOptionsParamsLocalTimeRegExp),
});

export type GetOverrideTimeOptionsParams = zod.input<typeof GetOverrideTimeOptionsParams>;
export type GetOverrideTimeOptionsParamsOutput = zod.output<typeof GetOverrideTimeOptionsParams>;
